import { useContext } from 'react';
import { IAuthContext, AuthContext } from './AuthContext';

const useAuth = (): IAuthContext => useContext(AuthContext);

export default useAuth;
